import {
  Form,
  Input,
} from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React from 'react'

import { required } from '@/utils/rules'

export function RoleEditFormFields() {
  return (
    <>
      <Form.Item name="id" hidden />
      <Form.Item
        label="Role name"
        required
        name="name"
        rules={[required('Role name is required')]}
        wrapperCol={{ sm: 24 }}
      >
        <Input size="large" placeholder="Role Name" count={{ show: true }} maxLength={50} />
      </Form.Item>
      <Form.Item label="Description" name="description" wrapperCol={{ sm: 24 }}>
        <TextArea
          size="large"
          placeholder="Describe the role (optional)"
          count={{ show: true }}
          maxLength={300}
        />
      </Form.Item>
    </>
  )
}
